export default "__VITE_ASSET__0cbffd87__"